import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

// Варианты стилей для кнопки с использованием class-variance-authority

const buttonVariants = cva(
  // Базовые стили для всех кнопок
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90",        // Основная кнопка
        destructive:
          "bg-destructive text-destructive-foreground hover:bg-destructive/90", // Деструктивная кнопка
        outline:
          "border border-input bg-background hover:bg-accent hover:text-accent-foreground", // Кнопка с обводкой
        secondary:
          "bg-secondary text-secondary-foreground hover:bg-secondary/80",       // Вторичная кнопка
        ghost: "hover:bg-accent hover:text-accent-foreground",                   // Прозрачная кнопка
        link: "text-primary underline-offset-4 hover:underline",                 // Кнопка-ссылка
      },
      size: {
        default: "h-10 px-4 py-2",    // Стандартный размер
        sm: "h-9 rounded-md px-3",    // Маленький размер
        lg: "h-11 rounded-md px-8",   // Большой размер
        icon: "h-10 w-10",           // Размер для иконки
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

// Интерфейс пропсов для компонента кнопки
export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean  // Флаг для рендера как дочерний элемент
}

// Основной компонент кнопки с поддержкой forwardRef
const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    // Выбираем компонент для рендера: Slot или обычная кнопка
    const Comp = asChild ? Slot : "button"
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    )
  }
)
Button.displayName = "Button"

export { Button, buttonVariants }
